/**
 * One sport's fixtures.
 *
 * As with the all-sports list, the table's `load` prop is `loadFixtures` itself
 * rather than a Server Action wrapping it.
 */

import { useParams } from "react-router-dom";

import { FixturesTable } from "@/components/fixtures/FixturesTable";
import { PageHead, Problem } from "@/components/kit";
import { displayName } from "@/lib/format";
import { loadFixtures } from "@/lib/fixtures/load";
import { useApi } from "@/spa/useApi";

export function SportFixturesPage() {
  const { sport = "" } = useParams<{ sport: string }>();
  const { data: page, loading, error } = useApi(
    () => loadFixtures({ sport }),
    [sport],
    "failed to load",
  );

  if (error) return <Problem>Could not load fixtures: {error}</Problem>;
  if (!page) {
    return <PageHead title={`${displayName(sport)} fixtures`} note={loading ? "Loading…" : ""} />;
  }

  return (
    <>
      <PageHead
        title={`${displayName(sport)} fixtures`}
        note={`${page.total} fixture${page.total === 1 ? "" : "s"} in this sport`}
      />
      <FixturesTable page={page} sports={[]} sport={sport} load={loadFixtures} />
    </>
  );
}
